// extracted by mini-css-extract-plugin
module.exports = {"addressBox":"styles_addressBox__y7Hi5","changeAddress":"styles_changeAddress__Xr8jA"};